import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "HOME", path: "/", testId: "nav-link-home" },
  { label: "PRODUCT", path: "/product", testId: "nav-link-product" },
  { label: "ARCHITECTURE", path: "/architecture", testId: "nav-link-architecture" },
  { label: "FOOD", path: "/food", testId: "nav-link-food" },
  { label: "MOTION / AI / VIDEO", path: "/motion-ai", testId: "nav-link-motion-ai" },
  { label: "ABOUT", path: "/about", testId: "nav-link-about" },
  { label: "CONTATTI", path: "/contact", testId: "nav-link-contact" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        data-testid="main-navbar"
        className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-300 ${
          scrolled ? "bg-night/85 backdrop-blur-xl border-b border-line" : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="flex items-center justify-between px-6 sm:px-12 lg:px-20 h-20">
          <Link to="/" data-testid="brand-logo" className="leading-none" aria-label="Nicola Verardo — Home">
            <img src="/media/nv/logo.png" alt="Nicola Verardo — Photography & Motion" className="h-10 w-auto" />
          </Link>
          <nav className="hidden lg:flex items-center gap-8" aria-label="Navigazione principale">
            {LINKS.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                data-testid={link.testId}
                className={({ isActive }) =>
                  `text-xs font-medium tracking-[0.15em] pb-1 border-b transition-[color,border-color] duration-300 ${
                    isActive
                      ? "text-bone border-gold"
                      : "text-fog border-transparent hover:text-bone"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <button
            data-testid="mobile-menu-button"
            onClick={() => setOpen(true)}
            className="lg:hidden text-bone p-2"
            aria-label="Apri menu"
          >
            <Menu size={24} />
          </button>
        </div>
      </header>

      {open && (
        <div
          data-testid="mobile-menu-overlay"
          className="fixed inset-0 z-[60] bg-night flex flex-col px-6 py-6"
        >
          <div className="flex items-center justify-between h-8">
            <img src="/media/nv/logo.png" alt="Nicola Verardo" className="h-8 w-auto" />
            <button
              data-testid="mobile-menu-close"
              onClick={() => setOpen(false)}
              className="text-bone p-2"
              aria-label="Chiudi menu"
            >
              <X size={24} />
            </button>
          </div>
          <nav className="flex flex-col gap-6 mt-16" aria-label="Menu mobile">
            {LINKS.map((link, i) => (
              <NavLink
                key={link.path}
                to={link.path}
                data-testid={`mobile-${link.testId}`}
                style={{ transitionDelay: `${i * 40}ms` }}
                className={({ isActive }) =>
                  `text-3xl font-light tracking-tight transition-colors duration-300 ${
                    isActive ? "text-gold" : "text-bone hover:text-gold"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>
          <p className="mt-auto text-xs font-mono tracking-[0.25em] text-fog">PHOTOGRAPHY. MOTION. AI. ONE VISUAL LANGUAGE.</p>
        </div>
      )}
    </>
  );
};

export default Navbar;
